webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(8)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(13),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CustomCropper_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CustomCropper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_CustomCropper_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    CustomCropper: __WEBPACK_IMPORTED_MODULE_0__components_CustomCropper_vue___default.a
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SelectBox_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SelectBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SelectBox_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SelectBox: __WEBPACK_IMPORTED_MODULE_0__SelectBox_vue___default.a
  },
  data: function data() {
    return {
      img: null,
      $srcImg: null,
      $resImg: null,
      $input: null,
      $imgContainer: null,
      $preContainer: null,
      nw: 0,
      nh: 0,
      clipData: null,
      ratio: 16 / 10,
      imgSize: { w: 0, h: 0 },
      containerTop: 0
    };
  },
  mounted: function mounted() {
    this.$input = this.$el.querySelectorAll('#file_input')[0];
    this.$srcImg = this.$el.querySelectorAll('#clip_src_img')[0];
    this.$resImg = this.$el.querySelectorAll('#clip_res_img')[0];
    this.$imgContainer = this.$el.querySelectorAll('.img-container')[0];
    this.$preContainer = this.$el.querySelectorAll('.pre-container')[0];
    this.$containerBox = this.$el.querySelectorAll('.container-bg')[0];
  },

  methods: {
    selectChange: function selectChange() {
      var rec = this.$refs.box.rec;
      if (rec.w > 0 && rec.h > 0) {
        this.updatePreview();
      }
    },
    selectEnd: function selectEnd() {
      var rec = this.$refs.box.rec;
      if (rec.w > 0 && rec.h > 0) {
        this.clip();
      }
    },
    fileChange: function fileChange() {
      var me = this;
      var fd = new FileReader();
      fd.onloadend = function () {
        me.img = fd.result;
      };
      if (this.$input.files && this.$input.files[0]) {
        fd.readAsDataURL(this.$input.files[0]);
      }
    },
    srcImgLoaded: function srcImgLoaded() {
      this.nw = this.$srcImg.naturalWidth;
      this.nh = this.$srcImg.naturalHeight;
      this.clearSelect();
      this.setImgSize();
      this.updatePreview();
      this.clip();
    },
    clearSelect: function clearSelect() {
      var box = this.$refs.box;
      box.clearRec();
      this.clipData = null;
    },
    setImgSize: function setImgSize() {
      var nr = this.nw / this.nh;
      var scw = this.$containerBox.offsetWidth;
      var sch = this.$containerBox.offsetHeight;
      var rw = 0;
      var rh = 0;
      if (nr >= this.ratio) {
        this.imgSize.w = scw;
        this.imgSize.h = scw / nr;
        this.containerTop = (sch - this.imgSize.h) / 2;
        rh = this.imgSize.h;
        rw = rh * this.ratio;
      } else {
        this.imgSize.h = sch;
        this.imgSize.w = sch * nr;
        this.containerTop = 0;
        rw = this.imgSize.w;
        rh = rw / this.ratio;
      }
      this.$srcImg.setAttribute('style', 'width:' + this.imgSize.w + 'px;height:' + this.imgSize.h + 'px;');
      this.$imgContainer.setAttribute('style', 'width:' + this.imgSize.w + 'px;height:' + this.imgSize.h + 'px;top:' + this.containerTop + 'px;');
      this.$refs.box.rec = { w: rw, h: rh, l: 0, t: 0 };
    },
    getComputedRec: function getComputedRec(r) {
      var cw = this.$imgContainer.offsetWidth;
      var ch = this.$imgContainer.offsetHeight;
      var wr = cw / this.nw;
      var hr = ch / this.nh;
      return {
        l: r.l / wr, t: r.t / hr,
        w: r.w / wr, h: r.h / hr
      };
    },
    updatePreview: function updatePreview() {
      var rec = this.$refs.box.rec;
      var pcw = this.$preContainer.offsetWidth;
      var pch = this.$preContainer.offsetHeight;
      var wr = pcw / rec.w;
      var hr = pch / rec.h;
      var w = wr * this.$imgContainer.offsetWidth;
      var h = hr * this.$imgContainer.offsetHeight;
      var l = -rec.l * wr;
      var t = -rec.t * hr;
      this.$resImg.setAttribute('style', 'width:' + w + 'px;height:' + h + 'px;top:' + t + 'px;left:' + l + 'px;');
    },
    clip: function clip() {
      var rec = this.$refs.box.rec;
      if (!rec.w || !rec.h) {
        return;
      }

      var bufferCanvas = document.createElement('canvas');
      var bfx = bufferCanvas.getContext('2d');
      var computedRec = this.getComputedRec(rec);
      bufferCanvas.width = computedRec.w;
      bufferCanvas.height = computedRec.h;
      bfx.drawImage(this.$srcImg, -computedRec.l, -computedRec.t, this.nw, this.nh);
      this.clipData = bufferCanvas.toDataURL('image/jpeg', 1);
    }
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    ratio: {},
    img: {},
    srcSize: {}
  },
  data: function data() {
    return {
      rec: {
        w: 0, h: 0, l: 0, t: 0
      },
      pl: 0,
      pt: 0,
      action: '',
      actionPoint: { x: 0, y: 0 },
      referPoint: { x: 0, y: 0 },
      $rec: null
    };
  },

  computed: {
    showBox: function showBox() {
      return this.rec.w && this.rec.h;
    },
    imgStyle: function imgStyle() {
      return 'width:' + this.srcSize.w + 'px;height:' + this.srcSize.h + 'px;top:' + -this.rec.t + 'px;left:' + -this.rec.l + 'px;';
    },
    recStyle: function recStyle() {
      return 'width:' + this.rec.w + 'px;height:' + this.rec.h + 'px;left:' + this.rec.l + 'px;top:' + this.rec.t + 'px;';
    }
  },
  mounted: function mounted() {
    window.addEventListener('mouseup', this.disableDrag);
    window.addEventListener('mousemove', this.updateRec);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('mouseup', this.disableDrag);
    window.removeEventListener('mousemove', this.updateRec);
  },

  methods: {
    getLeft: function getLeft(el) {
      var left = el.offsetLeft;
      var parent = el.offsetParent;

      while (parent) {
        left += parent.offsetLeft;
        parent = parent.offsetParent;
      }
      return left;
    },
    getTop: function getTop(el) {
      var top = el.offsetTop;
      var parent = el.offsetParent;

      while (parent) {
        top += parent.offsetTop;
        parent = parent.offsetParent;
      }
      return top;
    },
    initAction: function initAction(name, x, y) {
      this.action = name;
      this.pl = this.getLeft(this.$el);
      this.pt = this.getTop(this.$el);
      this.actionPoint = { x: x, y: y };
      this.referPoint = { x: this.rec.l, y: this.rec.t };

      if (name === 'drag-lt') {
        this.referPoint = { x: this.rec.l + this.rec.w, y: this.rec.t + this.rec.h };
      } else if (name === 'drag-lb') {
        this.referPoint = { x: this.rec.l + this.rec.w, y: this.rec.t };
      } else if (name === 'drag-rt') {
        this.referPoint = { x: this.rec.l, y: this.rec.t + this.rec.h };
      } else if (name === 'drag-rb') {
        this.referPoint = { x: this.rec.l, y: this.rec.t };
      }
    },
    pointMouseDown: function pointMouseDown(name, e) {
      this.initAction(name, e.pageX, e.pageY);
      e.stopPropagation();
    },
    boxMouseDown: function boxMouseDown(e) {
      this.initAction('move', e.pageX, e.pageY);
      e.stopPropagation();
    },
    wrapMouseDown: function wrapMouseDown(e) {
      if (this.rec.w && this.rec.h) {
        return;
      }
      this.initAction('cross', e.pageX, e.pageY);
      this.rec = {
        w: 0,
        h: 0,
        l: e.pageX - this.pl,
        t: e.pageY - this.pt
      };
      e.stopPropagation();
    },
    disableDrag: function disableDrag() {
      if (this.action) {
        this.action = '';
        this.$emit('selectEnd');
      }
    },
    clearRec: function clearRec() {
      this.action = '';
      this.rec = { w: 0, h: 0, l: 0, t: 0 };
    },
    updateRec: function updateRec(e) {
      if (!this.action) {
        return;
      }

      var elWidth = this.$el.offsetWidth;
      var elHeight = this.$el.offsetHeight;
      var dx = e.pageX - this.actionPoint.x;
      var dy = e.pageY - this.actionPoint.y;
      var x = e.pageX;
      var y = e.pageY;
      var w = 0;
      var h = 0;
      var t = 0;
      var l = 0;

      if (dx === 0 && dy === 0) {
        return;
      }

      if (this.action === 'move') {
        t = dy + this.referPoint.y;
        l = dx + this.referPoint.x;

        if (t <= 0) {
          t = 0;
        } else if (t + this.rec.h >= elHeight) {
          t = elHeight - this.rec.h;
        }

        if (l <= 0) {
          l = 0;
        } else if (l + this.rec.w >= elWidth) {
          l = elWidth - this.rec.w;
        }

        this.rec.l = l;
        this.rec.t = t;
      } else if (this.action === 'cross') {
        if (dx > 0 && dy > 0) {
          w = dx + this.rec.l >= elWidth ? elWidth - this.rec.l : dx;
          h = w / this.ratio;

          if (h + this.rec.t > elHeight) {
            h = elHeight - this.rec.t;
            w = h * this.ratio;
          }
          this.rec.w = w;
          this.rec.h = h;
        } else if (dx > 0 && dy < 0) {
          w = dx + this.referPoint.x >= elWidth ? elWidth - this.referPoint.x : dx;
          h = w / this.ratio;

          if (h >= this.referPoint.y) {
            h = this.referPoint.y;
            w = h * this.ratio;
          }

          this.rec.t = this.referPoint.y - h;
          this.rec.w = w;
          this.rec.h = h;
        } else if (dx < 0 && dy < 0) {
          w = dx + this.referPoint.x <= 0 ? this.referPoint.x : -dx;
          h = w / this.ratio;

          if (h >= this.referPoint.y) {
            h = this.referPoint.y;
            w = h * this.ratio;
          }

          this.rec.t = this.referPoint.y - h;
          this.rec.l = this.referPoint.x - w;
          this.rec.w = w;
          this.rec.h = h;
        } else if (dx < 0 && dy > 0) {
          w = dx + this.referPoint.x <= 0 ? this.referPoint.x : -dx;
          h = w / this.ratio;

          if (h + this.referPoint.y >= elHeight) {
            h = elHeight - this.referPoint.y;
            w = h * this.ratio;
          }

          this.rec.l = this.referPoint.x - w;
          this.rec.w = w;
          this.rec.h = h;
        }
      } else if (this.action === 'drag-lt' || this.action === 'drag-rt' || this.action === 'drag-lb' || this.action === 'drag-rb') {
        w = x - (this.referPoint.x + this.pl);
        h = y - (this.referPoint.y + this.pt);
        if (w < 0 && h < 0) {
          w = w * -1 >= this.referPoint.x ? this.referPoint.x : w * -1;
          h = w / this.ratio;

          if (h >= this.referPoint.y) {
            h = this.referPoint.y;
            w = h * this.ratio;
          }
          this.rec.l = this.referPoint.x - w;
          this.rec.t = this.referPoint.y - h;
        } else if (w < 0 && h > 0) {
          w = w * -1 >= this.referPoint.x ? this.referPoint.x : w * -1;
          h = w / this.ratio;

          if (h >= elHeight - this.referPoint.y) {
            h = elHeight - this.referPoint.y;
            w = h * this.ratio;
          }
          this.rec.l = this.referPoint.x - w;
          this.rec.t = this.referPoint.y;
        } else if (w > 0 && h < 0) {
          w = w >= elWidth - this.referPoint.x ? elWidth - this.referPoint.x : w;
          h = w / this.ratio;

          if (h >= this.referPoint.y) {
            h = this.referPoint.y;
            w = h * this.ratio;
          }
          this.rec.l = this.referPoint.x;
          this.rec.t = this.referPoint.y - h;
        } else if (w > 0 && h > 0) {
          w = w >= elWidth - this.referPoint.x ? elWidth - this.referPoint.x : w;
          h = w / this.ratio;

          if (h >= elHeight - this.referPoint.y) {
            h = elHeight - this.referPoint.y;
            w = h * this.ratio;
          }
          this.rec.l = this.referPoint.x;
          this.rec.t = this.referPoint.y;
        }

        this.rec.w = w;
        this.rec.h = h;
      }
      this.$emit('selectChange');
    }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(7)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(12),
  /* scopeId */
  "data-v-230e4956",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(9)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(14),
  /* scopeId */
  "data-v-73993fae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cropper-modal"
  }, [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-content clearfix"
  }, [_c('div', {
    staticClass: "img-clip-wrap"
  }, [_c('div', {
    staticClass: "container-bg"
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    attrs: {
      "id": "clip_src_img",
      "src": _vm.img
    },
    on: {
      "load": _vm.srcImgLoaded
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shadow-box"
  }), _vm._v(" "), _c('Select-Box', {
    ref: "box",
    attrs: {
      "srcSize": _vm.imgSize,
      "ratio": _vm.ratio,
      "img": _vm.img
    },
    on: {
      "selectEnd": _vm.selectEnd,
      "selectChange": _vm.selectChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "reset-img"
  }, [_c('i', {
    staticClass: "icon-reset"
  }), _vm._v(" "), _c('span', [_vm._v("select image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "file_input",
      "accept": "image/png,image/jpg,image/gif"
    },
    on: {
      "change": _vm.fileChange
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "img-preview-wrap"
  }, [_c('div', {
    staticClass: "pre-container"
  }, [_c('img', {
    attrs: {
      "id": "clip_res_img",
      "src": _vm.img
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pre-info"
  }, [_vm._v("preview")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('a', {
    staticClass: "modal-btn btn-confirm",
    attrs: {
      "href": _vm.clipData,
      "download": "crop.jpg"
    }
  }, [_vm._v("clip")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-head"
  }, [_c('div', {
    staticClass: "head-wrap"
  }, [_vm._v("title")])])
}]}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('custom-cropper')
},staticRenderFns: []}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crop-wrap",
    on: {
      "mousedown": _vm.wrapMouseDown
    }
  }, [_c('div', {
    staticClass: "shadow-box",
    style: (_vm.recStyle)
  }, [_c('img', {
    staticClass: "shadow-img",
    style: (_vm.imgStyle),
    attrs: {
      "src": _vm.img
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "crop-box",
    class: _vm.showBox ? 'show' : '',
    style: (_vm.recStyle),
    on: {
      "mousedown": _vm.boxMouseDown
    }
  }, [_c('span', {
    staticClass: "drag-point point-lt",
    on: {
      "mousedown": function($event) {
        _vm.pointMouseDown('drag-lt', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "drag-point point-lb",
    on: {
      "mousedown": function($event) {
        _vm.pointMouseDown('drag-lb', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "drag-point point-rt",
    on: {
      "mousedown": function($event) {
        _vm.pointMouseDown('drag-rt', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "drag-point point-rb",
    on: {
      "mousedown": function($event) {
        _vm.pointMouseDown('drag-rb', $event)
      }
    }
  })])])
},staticRenderFns: []}

/***/ })
],[3]);


// WEBPACK FOOTER //
// static/js/app.d4f1a4ff4b3f7612aec7.js